import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles(() => ({
  subtitle: { marginBottom: 16 },
  dot: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    display: "inline-block",
    marginRight: 8,
    flexShrink: 0,
    verticalAlign: "middle",
    backgroundColor: "#25D366",
  },
  menuItem: { display: "flex", alignItems: "center" },
}));

const SelectWhatsappModal = ({ open, onClose, onConfirm, available }) => {
  const classes = useStyles();
  const [selectedId, setSelectedId] = useState("");
  const [connections, setConnections] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    if (available && available.length > 0) {
      // available = [{ id, name }] — ya llega con nombres del endpoint resolve-whatsapp
      setConnections(available);
      setSelectedId(available[0].id);
      return;
    }
    // Fallback: pedir lista completa y filtrar por IDs si no vienen con nombre
    const fetchConnections = async () => {
      setLoading(true);
      try {
        const { data } = await api.get("/whatsapp/");
        setConnections(data.filter(w => w.status === "CONNECTED"));
        if (data.length > 0) setSelectedId(data[0].id);
      } catch (err) {
        toastError(err);
      }
      setLoading(false);
    };
    fetchConnections();
  }, [open, available]);

  const handleConfirm = () => {
    onConfirm(selectedId);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{i18n.t("tickets.selectWhatsappModal.title")}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" className={classes.subtitle}>
          {i18n.t("tickets.selectWhatsappModal.subtitle")}
        </Typography>
        {loading ? (
          <CircularProgress size={24} />
        ) : (
          <FormControl fullWidth variant="outlined" size="small">
            <InputLabel shrink>WhatsApp</InputLabel>
            <Select
              value={selectedId}
              onChange={e => setSelectedId(e.target.value)}
              label="WhatsApp"
            >
              {connections.map(w => (
                <MenuItem key={w.id} value={w.id} className={classes.menuItem}>
                  <span className={classes.dot} />
                  {w.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          {i18n.t("tickets.selectWhatsappModal.cancel")}
        </Button>
        <Button
          onClick={handleConfirm}
          color="primary"
          variant="contained"
          disabled={!selectedId || loading}
        >
          {i18n.t("tickets.selectWhatsappModal.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SelectWhatsappModal;
